import { render, staticRenderFns } from "./TierContributionAmountInput.vue?vue&type=template&id=60a248d4&"
import script from "./TierContributionAmountInput.vue?vue&type=script&lang=js&"
export * from "./TierContributionAmountInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports